<template lang="pug">
div(style="text-align:left")
	
	div(v-if="task.category == 'lunch'")
		p(style='margin-bottom:0px;')
			b.margin-right Lunch
	div(v-if="task.category == 'break'")
		p(style='margin-bottom:0px;')
			b.margin-right Break
	div(v-if="task.category == 'travel'")
		p(style='margin-bottom:0px;')
			b.margin-right Travel
	div(v-if="task.category == 'ga'")
		p(style='margin-bottom:0px;')
			b.margin-right General Administrative
	div(v-if="task.category == 'personal'")
		p(style='margin-bottom:0px;')
			b.margin-right Personal Time
			
	div(v-if='task.category=="line-item"')
		.float-left
			i.icon-cp-icons_Jobs.margin-right
		p(style='margin-bottom:0px;')
			b(v-if=`task.job_code`).margin-right {{task.job_code}}
			span {{task.job_name}}
			b(v-if=`task.job`).margin-right {{task.job.code}}
			span(v-if=`task.job`) {{task.job.name}}
			br
			span(v-if='task').ellipse
				span(v-if='task.phaseCode').phaseCode.margin-right Phase: {{task.phaseCode}}
				span(v-if='task.phaseCode && task.costCode').margin-right |
				span(v-if='task.costCode').margin-right.costCode Cost: {{task.costCode}}
				span(v-if='(task.phaseCode || task.costCode) && task.changeOrder').margin-right |
				span(v-if='task.changeOrder').margin-right ({{task.changeOrder}})
				span(v-if='task.phaseCode || task.costCode').margin-right -
				span {{task.name}}
	div(v-if='task.category=="equipment"')
		.float-left
			i.icon-cp-icons_Equipment.margin-right
		p(style='margin-bottom:0px;')
			b(v-if=`task.code`).margin-right {{task.code}}
			span {{task.name}}
	div(v-if='task.category=="workorder"')
		.float-left
			i.icon-cp-icons_Work-orders.margin-right
		p(style='margin-bottom:0px;')
			b(v-if=`task.code`).margin-right {{task.code}}
			span {{task.name}}
</template>

<script>
export default {
  name: "TaskLabel",

  props: ["task"],
  mounted: function() {}
};
</script>

<style scoped lang="less">
</style>
